<template>
  <div class="myZrqListPageNew">
    <van-cell-group class="currentZrqPosition" v-if="mapDataType">
      <van-field
        label="当前："
        left-icon="location-o"
        :right-icon="myzrqList[1] ? 'arrow' : ''"
        v-model="zrqName"
        readonly
        @click="checkZrqPicker"
      />
    </van-cell-group>
    <div class="forestBox" v-if="mapDataType">
      <!-- 地图页 -->
      <div
        :class="[
          'forestMap',
          checkMoreType == true ? 'bigForestMap' : '',
          zrqName != '' ? '' : 'bigMap',
        ]"
      >
        <!-- <zrq :mapData="mapData" mode="h5"></zrq> -->
        <map-locator :param="mapData" mode="h5"></map-locator>
        <span class="checkMore" @click="changeMapHight"
          >{{ checkMoreType ? "展开" : "收起" }}
          <van-icon v-if="!checkMoreType" name="arrow-up" /><van-icon
            v-if="checkMoreType"
            name="arrow-down"
        /></span>
      </div>
      <div class="forestTab" v-if="zrqName">
        <van-tabs v-model="oneActiveName">
          <van-tab
            :title="tabTypeText == 'zrq' ? '责任区信息' : '政区信息'"
            name="dutyAreatMsg"
            class="baseZrqMsg"
          >
            <duty-area-msg
              :dataInfo="param"
            ></duty-area-msg>
            <!-- <zq-area-msg :dataInfo="param" v-else></zq-area-msg> -->
          </van-tab>
          <van-tab
            title="资源信息"
            name="dutyAreaEvaluate"
            class="dutyAreaEvaluate"
          >
            <area-affiliation :dataInfo="param"></area-affiliation>
          </van-tab>
          <van-tab
            v-for="(item, index) in msgList"
            :key="item.id"
            :title="item.postName"
            :name="'dutyArea' + index"
          >
            <duty-area-policy :dataInfo="item"></duty-area-policy>
          </van-tab>
          <van-tab title="电子公示牌" name="dutyBillboard">
            <billboard :dataInfo="param"></billboard>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <!-- 弹出框 -->
    <van-popup v-model="selectZrqPicker" class="zrqPickerPage">
      <zrq-select :zrqData="zrqData" @getData="changeZrq"></zrq-select>
    </van-popup>
    <div class="nonePage" v-if="!mapDataType">
      <img :src="nonePng" alt />
      <p>暂无责任区</p>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
const mapLocator = () => import("@/components/map/MapLocatorNew");
const zrq = () => import("@/views/map/Zrq");
const refreshPage = () => import("@/components/common/refreshPage");
const dutyAreaMsg = () =>
  import("@/components/linLongModule/linDetailModule/zrqAreaMsg");
const zqAreaMsg = () =>
  import("@/components/linLongModule/linDetailModule/zqAreaMsg");
const dutyAreaPolicy = () =>
  import("@/components/linLongModule/linDetailModule/areaPolicy");
const areaAffiliation = () =>
  import("@/components/linLongModule/linDetailModule/myRecord");
const billboard = () => import("@/components/dutyAreaModule/commonPublicity");

const zrqSelect = () => import("@/components/zrqSelect/zrqSelect");
import nonePng from "@/assets/none.png";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "myZrqList",
  components: {
    dutyAreaMsg,
    zqAreaMsg,
    areaAffiliation,
    dutyAreaPolicy,
    zrq,
    zrqSelect,
    billboard, //公示牌
    mapLocator,
  },
  data() {
    return {
      userObjid: "",
      userId: "",
      linUserId: "",
      gridLevel: "", //责任区等级
      gridType: "", //责任区类型
      mapData: {
        zrqlx: "",
        zrqobjid: "",
        zqCode: "",
        toolbar: "none",
      },
      mapDataType: "", //有无责任区
      zrqData: {
        uid: "",
        objid: "",
        zrqName: "",
      },
      tabTypeText: "",
      param: {
        objid: "",
        type: "",
        level: "",
        zqCode: "",
      },
      interiorPoint: "",
      oneActiveName: "dutyAreatMsg", //默认选中第一项
      msgList: [], //根据责任区|政区获取文本信息list
      showLoadPage: true,
      zrqName: "",
      myzrqList: [],
      selectZrqPicker: false,
      checkMoreType: false,
      nonePng: nonePng, //默认图片
      clientType: "", //手机类型
    };
  },
  props: {
    childType: {
      type: String,
    },
  },
  mounted() {
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      if (this.childType == "linLongMsg") {
        this.userId = this.$route.query.uid;
        this.initData();
      } else {
        this.initPage();
      }
    });
  },
  methods: {
    checkZrqPicker() {
      if (this.myzrqList[1]) {
        this.selectZrqPicker = true;
      }
    },
    changeMapHight() {
      this.checkMoreType = !this.checkMoreType;
    },
    getlinUserMsg() {
      let _this = this;
      _this.$api.universal
        .linLongMsg(_this.userObjid)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            this.userId = res.data.uid;
            this.initData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initPage() {
      this.userId = this.$route.query.commonId;
      this.initData();
    },
    initData() {
      let _this = this;
      _this.$api.universal.dutyArea
        .getDutyAreaList(_this.userId)
        .then((res) => {
          if (res.code == "1" && res.data[0]) {
            _this.mapDataType = true;
            _this.linUserId = _this.userId;
            _this.myzrqList = res.data;
            _this.param.objid = res.data[0].objid;
            _this.param.type = res.data[0].type;
            _this.param.level = res.data[0].level;
            _this.param.zqCode = res.data[0].zqCode;
            _this.tabTypeText = res.data[0].type;
            _this.mapData.zrqlx = _this.getZrqLx(
              res.data[0].type,
              res.data[0].level
            );
            _this.mapData.zrqobjid = res.data[0].objid;
            _this.mapData.zqCode = res.data[0].zqCode;
            _this.zrqName = res.data[0].zqName;
            _this.zrqData.uid = _this.userId;
            _this.zrqData.objid = res.data[0].objid;
            _this.zrqData.zrqName = res.data[0].zqName;
            _this.getGridArchives(
              res.data[0].type,
              res.data[0].level,
              res.data[0].objid,
              res.data[0].zqCode
            );
          } else {
            _this.mapDataType = false;
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGridArchives(type, level, objid, zqCode) {
      let _this = this;

      _this.$api.universal.dutyArea
        .getGridArchives({
          type: type,
          level: level,
          objid: objid,
          zqCode: zqCode ? zqCode : "",
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.msgList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeZrq(data) {
      console.log(666666);
      console.log(data);
      let _this = this;
      this.selectZrqPicker = false;
      _this.getGridArchives(data.type, data.level, data.objid, data.zqCode);
      if (data.objid && data.zrqName) {
        _this.param.objid = data.objid;
        _this.param.type = data.type;
        _this.tabTypeText = data.type;
        _this.mapData.zqCode = data.zqCode;
        _this.mapData.zrqobjid = data.objid;
        _this.$set(
          _this.mapData,
          "zrqlx",
          _this.getZrqLx(data.type, data.level)
        );
        
        _this.zrqName = data.zrqName;
        _this.zrqData.uid = _this.userId;
        _this.zrqData.objid = data.objid;
        _this.zrqData.zrqName = data.zrqName;
      }
    },
    getZrqLx(type, level) {
      let lx = "",
        zqList = ["geo_sheng", "geo_shi", "geo_xian", "geo_xiang", "geo_cun"],
        zrqList = [
          "geo_grid_sheng",
          "geo_grid_shi",
          "geo_grid_xian",
          "geo_grid_xiang",
          "geo_grid_cun",
        ];
      if (type == "zq") {
        lx = zqList[level - 1];
      } else {
        lx = zrqList[level - 1];
      }
      return lx;
    },
  },
  watch: {
    childType(newVal) {
      if (newVal == "linLongMsg") {
        this.userObjid = this.$route.query.commonId;
        this.getlinUserMsg();
      } else {
        this.initPage();
      }
    },
  },
};
</script>
<style lang="less">
.myZrqListPageNew {
  width: 100%;
  height: 100%;
  position: relative;
  .currentZrqPosition {
    .van-field__label {
      width: 55px;
    }
    .van-field__left-icon {
      color: #4bc08a;
    }
    .van-cell__title {
      span {
        font-size: 15px;
        color: #626064;
      }
    }
    .van-cell__value {
      .van-field__control {
        text-align: left;
        font-size: 15px;
        color: #4bc985;
      }
    }
  }
  .forestBox {
    width: 100%;
    height: calc(100% - 45px);
    overflow-y: scroll;
  }
  .forestMap {
    width: 100%;
    height: 80%;
    position: relative;
    .checkMore {
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 12px;
      color: #4bc08a;
    }
    > div {
      height: 100%;
    }
    .gisinfobox {
      bottom: 5px !important;
    }
  }
  .bigForestMap.forestMap {
    height: 40%;
  }
  .bigMap.forestMap {
    height: 100%;
  }
  .forestTab {
    width: 100%;
    height: calc(100% - 45px);
    > .van-tabs {
      height: 100%;

      .van-tabs__line {
        background-color: #4bc08a;
      }
      .van-tab--active {
        .van-tab__text {
          color: #4bc08a;
        }
      }
      .van-tabs__wrap {
        height: 45px;
      }
      > .van-tabs__content {
        width: 100%;
        // height: calc(100% - 45px);
        height: 100%;
        > .van-tab__pane {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .zrqPickerPage {
    width: 100%;
    height: 100%;
  }
  .van-popup--center.zrqPickerPage {
    top: 0;
    left: 0;
    transform: initial;
  }
  .nonePage {
    width: 120px;
    height: 150px;

    position: absolute;
    left: 50%;
    margin-left: -60px;
    top: 50%;
    margin-top: -75px;

    img {
      display: block;
      max-width: 100px;
      max-height: 100px;
      margin: 0 auto;
    }

    p {
      margin-top: 10px;
      text-align: center;
      color: #5c5d5d;
      font-size: 16px;
    }
  }
}
</style>